import { EventMapService } from '../../../../services'

export const UPSELL_FLOWS = {
  CAMPAIGN_DOWNLOAD: 'campaign_download',
  ARTS_LIMIT: 'arts_limit',
  SUBSCRIBED_ARTS_LIMIT: 'subscribed_arts_limit',
}

export async function trackUpsellPopupView({
  flow,
  campaignId,
  step,
  tab,
  extra,
}) {
  return EventMapService.postEventMap({
    event: 'campaign_upsell_popup_view',
    eventData: {
      flow,
      ...(campaignId ? { campaignId } : {}),
      ...(step ? { step } : {}),
      ...(tab ? { tab } : {}),
      ...extra,
    },
  })
}

export async function trackUpsellExitFeedback({
  flow,
  campaignId,
  reasonId,
  reasonLabel,
}) {
  return EventMapService.postEventMap({
    event: 'campaign_upsell_exit_feedback',
    eventData: {
      flow,
      ...(campaignId ? { campaignId } : {}),
      reasonId,
      reasonLabel,
    },
  })
}
